import React from 'react';

import { Badge, ProfileCard } from '@change/ds-core-ui';
import { DecisionMakerIcon } from '@change/ds-icons';

import { useI18n } from '@change-corgi/core/react/i18n';

import dmAvatar from 'src/assets/sap/decision-maker-avatar.png';

import { InfoSection } from '../components/InfoSection';

export const DecisionMakerSection: React.FC<Props> = ({ className }) => {
	const { translate, localizeNumber } = useI18n();

	return (
		<InfoSection
			className={className}
			icon={
				<DecisionMakerIcon
					size="medium"
					aria-label={translate('corgi.start_a_petition.chat_app_entry.decision_makers_section.decision_makers_alt')}
				/>
			}
			title={translate('corgi.start_a_petition.chat_app_entry.decision_makers_section.title')}
			subtitle={translate('corgi.start_a_petition.chat_app_entry.decision_makers_section.subtitle')}
			badge={translate('corgi.start_a_petition.chat_app_entry.decision_makers_section.notified_badge', {
				count: localizeNumber(1000),
			})}
		>
			<ProfileCard
				name="Jennifer Madgic"
				avatar={dmAvatar}
				imgAlt={translate('corgi.start_a_petition.chat_app_entry.decision_makers_section.decision_makers_avatar_alt')}
				userRole={translate('corgi.start_a_petition.chat_app_entry.decision_makers_section.decision_makers_role')}
				className="elevation-elevated bg-fill-inverse-strong m-auto w-full"
				icon={
					<DecisionMakerIcon
						aria-label={translate('corgi.start_a_petition.chat_app_entry.decision_makers_section.decision_makers_alt')}
					/>
				}
			>
				<Badge
					label={translate('corgi.start_a_petition.chat_app_entry.decision_makers_section.decision_makers_badge')}
					variant="success"
					emphasis="weaker"
					className="self-center"
				/>
			</ProfileCard>
		</InfoSection>
	);
};

type Props = {
	className?: string;
};
